<script>
    import DataTable from '../../../admin-panel/classes/global/DataTable';

    export default {
        props: ['ajaxUrl', 'token',],
        data() {
            return {
                params: {},
                tableInit: false,
                user_id: null,
                consultant_group_id: null,
                lastBreadcrumb: _t('All'),
            }
        },
        mounted() {

            let that = this;
            let $table = $(this.$refs['orderDataTable']);
            let $panelHeading = $(this.$refs['panel_heading']);

            Event.$on('downlineOrdersFetched', (user_id, consultant_group_id, breadCrumbs) => {
                this.user_id = user_id;
                this.consultant_group_id = consultant_group_id;

                if(breadCrumbs.length){
                    this.lastBreadcrumb = breadCrumbs[breadCrumbs.length - 1].text;
                }else{
                    this.lastBreadcrumb = _t('All');
                }

                let initParams = JSON.parse($table.attr('data-params'));
                initParams.ajax.data.user_id = this.user_id;
                initParams.ajax.data.consultant_group_id = this.consultant_group_id;
                $table.attr('data-params', JSON.stringify(initParams));

                if($.fn.dataTable.isDataTable($table)){
                    let $title = $panelHeading.find('.list-list-title');
                    $title.text(_t('Orders list :last_breadcrumb', {last_breadcrumb: this.lastBreadcrumb}));
                    $table.DataTable().clear().destroy();
                    DataTable.prototype.draw($table);
                } else {
                    let $title = $('<h2 class="list-list-title" style="font-size: 14px; margin-top:0; margin-bottom: 10px;"></h2>');
                    $title.text(_t('Orders list :last_breadcrumb', {last_breadcrumb: this.lastBreadcrumb}));
                    $panelHeading.prepend($title);
                    DataTable.prototype.draw($table);
                }
            });

        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/orders/ordersTable.vue